import cn from 'classnames';
import React from 'react';
import { Button } from 'reactstrap';

import { HomeworkOnPageType } from 'shared/types/notebookTypes';

interface Props {
  isDisabled?: boolean;
  onClick: () => void;
  homework: HomeworkOnPageType | null;
}

export const AddHomeworkButton = ({ onClick, isDisabled, homework }: Props) => (
  <Button
    onClick={onClick}
    className={cn('add-homework', isDisabled && 'disabled', homework && 'withHomeWorkButton')}
    disabled={isDisabled}
  >
    Додати ДЗ
  </Button>
);
